export default {
	methods: {
		convertSetupProgressJsonToObj(setupProgress) {
			let setupProgressObj = {}
			if (typeof setupProgress == 'object') {
				setupProgressObj = setupProgress
			}
			else {
				try {
					setupProgressObj = JSON.parse(setupProgress)
				}
				catch (e) {}
				
			}

			return setupProgressObj
		},
		setupSectionIsComplete(section) {
			let settingsJson = ""

			if ("CompanySetting" in this.$store.company && this.$store.company.CompanySetting && "setup_progress_json" in this.$store.company.CompanySetting) {
				settingsJson = this.$store.company.CompanySetting.setup_progress_json
				
				this.$store.fetchingSetupStatus = false
			}

			let setupProgressObj = this.convertSetupProgressJsonToObj(settingsJson)

			if (section in setupProgressObj && setupProgressObj[section])
				return true
			else
				return false
		}
	}
}